import React from "react";
import { Modal, Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

interface DeleteConfirmationModalProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
  title?: string;
  message?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  visible,
  onConfirm,
  onCancel,
  loading = false,
  title = "Are you sure you want to delete the record?",
  message = "This action can't be undone.",
}) => {
  return (
    <Modal
      title={title}
      open={visible}
      onCancel={onCancel}
      footer={
        <div
          className="flex justify-end gap-2"
          style={{
            borderTop: "1px solid #f0f0f0",
            paddingTop: "16px",
            marginLeft: "-24px",
            marginRight: "-24px",
            paddingLeft: "24px",
            paddingRight: "24px",
            marginBottom: "-20px",
            paddingBottom: "20px",
          }}
        >
          <Button onClick={onCancel} disabled={loading} className="border-none">
            Cancel
          </Button>
          <Button
            type="primary"
            danger
            onClick={onConfirm}
            loading={loading}
            className="!bg-red-700"
          >
            Confirm
          </Button>
        </div>
      }
      width={400}
      closable={true}
      centered
      styles={{
        header: {
          backgroundColor: "#f5f5f5",
          marginLeft: "-24px",
          marginRight: "-24px",
          marginTop: "-20px",
          paddingLeft: "24px",
          paddingRight: "24px",
          paddingTop: "16px",
          paddingBottom: "16px",
        },
      }}
    >
      <div className="py-2">
        <p className="text-base mb-0 text-gray-600">{message}</p>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
